module.exports = __webpack_public_path__ + "img/edp.8442d2d9.svg";